import React, { useContext, useRef, useEffect, useState } from 'react';
import { store } from 'components/Store';
import ResearchBarItems from './ui/ResearchBarItems';
import ResearchPopUp from './ui/ResearchPopUp';
import useResetReference from './useResetReference';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import { useLocation, useNavigate } from 'react-router-dom';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';

const SearchResultsBar = (props) => {
  return <ResearchContent />;
};

const ResearchContent = (props) => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { referenceState, openResearchPopup, activePlan, search } = state;
  const { enableAdvancedSearch } = activePlan;
  const { activeSearch, query } = search;
  const { resetReference } = useResetReference();

  const openParam = getUrlParam('open');
  const [keywordsSection, setKeywordsSection] = useState('keywords');
  const [showPopup, setShowPopup] = useState(!!openParam);
  const closeKeywordsSection = () => {
    setKeywordsSection('keywords');
  };

  useEffect(() => {
    setShowPopup(!!openParam);
  }, [openParam]);

  const isMobile = useIsMobile();
  const location = useLocation();
  const navigate = useNavigate();
  const { newAgencyPlan } = useTopicOrClientWord();

  const showPopupFromEmptyMessage = useRef(null);
  showPopupFromEmptyMessage.current = () => {
    if (openResearchPopup) {
      setShowPopup(true);
      dispatch({ type: 'MODIFY_SECTION', parameter: 'openResearchPopup', value: false });
    }
  };

  useEffect(() => {
    showPopupFromEmptyMessage.current();
  }, [openResearchPopup]);

  const searchBarText = () => {
    let text = '';
    const { keywords, andKeywords, keywordExclusions, activeReference } = referenceState;
    const searchCondition = activeSearch && !newAgencyPlan;
    if (activeReference || searchCondition) {
      if (keywords.length > 0 || !!query) {
        text += `Showing results for <span>${
          !!query ? query : keywords.map((item) => `'${item}'`).join(' or ')
        }</span>`;
      }
      if (andKeywords.length > 0) {
        text += ` AND ALSO <span>${andKeywords.map((item) => `'${item}'`).join(' or ')}</span>`;
      }
      if (keywordExclusions.length > 0) {
        text += ` BUT NOT <span>${keywordExclusions.map((item) => `'${item}'`).join(' or ')}</span>`;
      }
    } else {
      if (!newAgencyPlan && !isMobile) {
        text = `Showing all updates on PolicyMogul`;
      }
    }
    return text;
  };

  return (
    <>
      <ResearchBarItems
        openPortal={() => {
          setShowPopup(true);
        }}
        referenceState={referenceState}
        clearSearch={resetReference}
        setKeywordsSection={setKeywordsSection}
        searchBarText={searchBarText()}
        enableAdvancedSearch={enableAdvancedSearch}
      />
      <ResearchPopUp
        showPopUp={showPopup}
        setShowPopup={(value) => {
          setShowPopup(value);
          const searchParams = new URLSearchParams(location.search);
          searchParams.delete('open');
          navigate({ search: searchParams.toString() });
        }}
        referenceState={referenceState}
        keywordsSection={keywordsSection}
        additionalCloseAction={closeKeywordsSection}
      />
    </>
  );
};

export default SearchResultsBar;
